// React reference: src/features/Home/Hero/hero.constants.ts PIPELINE_TICK_MS.
const TICK_MS = 2000;
const ACTIVE_CLASSES = [ 'text-grey-100', 'font-medium' ];
const INACTIVE_CLASSES = [ 'text-grey-70', 'font-normal' ];

function initBreadcrumb( block ) {
	let stages = [];
	try {
		stages = JSON.parse( block.dataset.stages || '[]' );
	} catch {
		stages = [];
	}

	if ( ! Array.isArray( stages ) || stages.length < 2 ) {
		return;
	}

	// Found by data attribute, not by class: the class list has to stay
	// identical to the React component's, which carries no JS hook.
	const stageEls = Array.from( block.querySelectorAll( '[data-index]' ) );

	if ( stageEls.length !== stages.length ) {
		return;
	}

	// Reduced motion (T-085): the served state (the first stage active) stays.
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	let active = 0;

	setInterval( () => {
		stageEls[ active ].classList.remove( ...ACTIVE_CLASSES );
		stageEls[ active ].classList.add( ...INACTIVE_CLASSES );

		active = ( active + 1 ) % stageEls.length;

		stageEls[ active ].classList.remove( ...INACTIVE_CLASSES );
		stageEls[ active ].classList.add( ...ACTIVE_CLASSES );
	}, TICK_MS );
}

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll( '.wp-block-avoid-content-hero-pipeline-breadcrumb' )
		.forEach( initBreadcrumb );
} );
